import { useParams } from "react-router-dom";import React from "react";
import { Link } from "react-router-dom"; 
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPinterestP,
  FaTwitter,
} from "react-icons/fa";

import blogs from "../../../data/innerpages/blog/blogContent.json";

function Content() {

     const { slug } = useParams();

  const blog = blogs.find((item) => item.slug === slug);

  if (!blog) {
    return <h1>Blog Not Found</h1>;
  }


  const recentBlogs = [
    {
      id: 1,
      title: "Top Interior Design Trends in 2026",
      image:
        "/innerpages/assets/img/blog/Automation Insights_scene_1_shot_3.jpeg",
      date: "May 08, 2026",
      alt: "Top Interior Design Trends",
      link: "/innerpages/blog",
    },
    {
      id: 2,
      title: "Modern Architecture & Smart Spaces",
      image: "/innerpages/assets/img/blog/02-EXPERIENCE CENTRE.jpg",
      date: "May 01, 2026",
      alt: "Modern Architecture & Smart Spaces",
      link: "/innerpages/blog",
    },
    {
      id: 3,
      title: "How Internships Shape Future Architects",
      image:
        "/innerpages/assets/img/blog/03-saloon experience center-db-architekt.jpeg",
      date: "April 28, 2026",
      alt: "How Internships Shape Future Architects",
      link: "/innerpages/blog",
    },
  ];

  const services = [
   { title: "Architecture Design", link : "/innerpages/services"},
   { title: "Interior Design", link : "/innerpages/services"},
    {title: "Urban Planning", link : "/innerpages/services"},
   { title: "3D Visualization", link : "/innerpages/services"},
   { title: "Site Planning", link : "/innerpages/services"},
  ];

  const tags = [
    "Architecture",
    "Interior",
    "Design",
    "Creative",
    "Modern",
    "Building",
  ];

  const sectors = [
    {title: "Residence", link: "/innerpages/Sector",},
    {title: "Housing",  link: "/innerpages/Sector",},
    {title: "Farm House", link: "/innerpages/Sector",},
    {title: "Hospitality", link: "/innerpages/Sector",},
    {title: "Institutional", link: "/innerpages/Sector",},
    {title: "Corporate Interior", link: "/innerpages/Sector",},
    {title: "Retails and F & B", link: "/innerpages/Sector",},
    {title: "Industrial Design", link: "/innerpages/Sector",},
  ];



  return (
    <section className="architect-blog-details blogs-section-padding">
      <div className="container">

        {/* ===== TOP BREADCRUMB ===== */}
        <div className="blog-top-info mb-80">

          <div className="architect-breadcrumb mb-10">
            <Link to="/">Home</Link>
            <span>/</span>
            <Link to="/innerpages/blog">Blogs</Link>
            <span>/</span>
            <span className="active">
              {blog.title}
            </span>
          </div>

        </div>

        {/* ===== 3 COLUMN LAYOUT ===== */}
        <div className="row">

          {/* ===== LEFT SIDEBAR ===== */}
          <div className="col-lg-3">

            {/* Recent Blogs */}
            <div className="architect-sidebar-card mb-40">

              <h5 className="architect-sidebar-title">
                Recent Blogs
              </h5>

              {recentBlogs.map((blog) => (
                <div className="architect-recent-post" key={blog.id}>

                  <div className="recent-post-img">
                    <img
                      src={blog.image}
                      alt={blog.alt}
                      className="img-cover"
                    />
                  </div>

                  <div className="recent-post-info">

                    <small>{blog.date}</small>

                    <h6>
                      <Link to={blog.link}>
                        {blog.title}
                      </Link>
                    </h6>

                  </div>

                </div>
              ))}

            </div>

            {/* Services */}
            <div className="architect-sidebar-card">

              <h5 className="architect-sidebar-title">
                Services
              </h5>

              <ul className="services-list">

                {services.map((service, index) => (
  <li key={index}>
    <Link to={service.link}>
      {service.title}
    </Link>
  </li>
))}

              </ul>

            </div>

          </div>

          {/* ===== CENTER BLOG CONTENT ===== */}
         <div className="col-lg-6 mt-5 mt-lg-0">

  <div className="architect-blog-main">

    {/* Blog Meta */}
    <div className="architect-blog-meta mb-20">

      <span>{blog.category}</span>

      <span className="meta-dot"></span>

      <span>{blog.date}</span>

    </div>

    {/* Blog Title */}
    <h1 className="architect-blog-title mb-30">
      {blog.title}
    </h1>

    {/* Main Image */}
    <div className="architect-main-image mb-40">

      <img
        src={blog.mainImage}
        alt={blog.title}
        className="img-cover"
      />

    </div>

    {/* Blog Content */}
    <div className="architect-blog-content">

      {blog.content?.map((item, index) => {

        // Paragraph
        if (item.type === "paragraph") {
          return (
            <p
              className="content-text"
              key={index}
            >
              {item.text}
            </p>
          );
        }

        // Heading
        if (item.type === "heading") {
          return (
            <h3
              className="content-title"
              key={index}
            >
              {item.text}
            </h3>
          );
        }

        // List
       if (item.type === "list") {
  return (
    <ul className="architect-content-list" key={index}>
      {item.items.map((listItem, i) => {

        // If old format (string)
        if (typeof listItem === "string") {
          return <li key={i}>{listItem}</li>;
        }

        // If new format (object with bold/text)
        return (
          <li key={i}>
            {listItem.bold && <strong className="text-gray">{listItem.bold}</strong>}{" "}
            {listItem.text || ""}
          </li>
        );

      })}
    </ul>
  );
}

        // Image
        if (item.type === "image") {
          return (
            <div
              className="architect-details-image my-50"
              key={index}
            >

              <img
                src={item.src}
                alt={item.alt}
                className="img-cover"
              />

            </div>
          );
        }

        return null;

      })}

    </div>

    {/* ===== FOLLOW US ===== */}
    <div className="architect-follow-us">

      <h5>
        Follow Us
      </h5>

      <div className="follow-social-icons">

        <Link
          to="https://www.facebook.com/dbarchitekt/"
          target="_blank"
        >
          <FaFacebookF />
        </Link>

        <Link
          to="https://www.instagram.com/db.architekt/"
          target="_blank"
        >
          <FaInstagram />
        </Link>

        <Link
          to="https://in.linkedin.com/company/dbarchitekt"
          target="_blank"
        >
          <FaLinkedinIn />
        </Link>

        <Link
          to="https://www.youtube.com/channel/UC2Vxn_hmgyO_tloro3RH-8Q"
          target="_blank"
        >
          <FaPinterestP />
        </Link>

      </div>

    </div>

  </div>

</div>

          {/* ===== RIGHT SIDEBAR ===== */}
          <div className="col-lg-3 mt-5 mt-lg-0">

            <div className="architect-sidebar-card">

              <h5 className="architect-sidebar-title">
                Tags
              </h5>

              <div className="architect-tags">

                {tags.map((tag, index) => (
                  <Link to="#" key={index}>
                    {tag}
                  </Link>
                ))}

              </div>

            </div>
    
               {/* Sector */}
            <div className="architect-sidebar-card">

              <h5 className="architect-sidebar-title">
                Sectors
              </h5>

              <ul className="services-list">

                {sectors.map((sectors, index) => (
                  <li key={index}>
                    <Link to={sectors.link}>
                      {sectors.title}
                    </Link>
                  </li>
                ))}

              </ul>

            </div>

          </div>

          

        </div>

      </div>
    </section>
  );
}

export default Content;